module.exports = __webpack_public_path__ + "static/media/favicon.4eb04f9b.ico";